// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let afflictionTypeEnum = {
    'Pest': 0,
    'Disease': 1
};

export default afflictionTypeEnum;
